<div id="menu" class="main-menu" *ngIf="!item.role || item.role.includes(role)">
  <!-- Nav item using an anchor tag -->
  <a
    mat-list-item
    [ngStyle]="{ 'padding-left': depth * 16 + 'px' }"
    (click)="onItemSelected(item)"
    [ngClass]="{
      active: item.route ? router.isActive(item.route, true) : false,
      expanded: expanded
    }"
    *ngIf="!item.role || item.role.includes(role)"
    class="menu-list-item"
  >
    <!-- Content container -->
    <div style="display: flex; align-items: center; width: 100%">
      <!-- Icon and display name -->
      <mat-icon class="routeIcon">{{ item.iconName }}</mat-icon>
      <span class="menu-item-text">{{ item.displayName }}</span>
      <span style="flex-grow: 1"></span>
      <!-- Spacer to push twistie to the right -->

      <!-- Twistie for sub-menus -->
      <span *ngIf="item.children && item.children.length">
        <mat-icon
          class="menu-twistie"
          [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"
          [ngClass]="{ expanded: expanded }"
        >
          expand_more
        </mat-icon>
      </span>
    </div>
  </a>
</div>

<!-- Recursive sub-menu component -->
<div *ngIf="expanded">
  <app-menu
    *ngFor="let child of item.children"
    [item]="child"
    [depth]="depth + 1"
    (closeSide)="closeSide.emit(true)"
  ></app-menu>
</div>
